import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { useState, useEffect } from 'react'
import InputAdornment from '@mui/material/InputAdornment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getAllElement } from '../../services/getAllElement';
import { getListaUtenzeAssegnatariMonitoraggio } from '../../services/getListaUtenzeAssegnatariMonitoraggio';

const esitoSintetico = [
  "SI",
  "NO",
];
const esitoMonitoraggioFondi = [
  "SI",
  "NO",
];

const inSofferenzaList = [
  "SI",
  "NO",
];

const gestoreList=JSON.parse(localStorage.getItem('DaAssegnareMonitoraggio'))


  const selectTypeSearch = ['Uguale', 'Diverso'];
  const textTypeSearch = ['Uguale', 'Contiene'];
  const dateTypeSearch = ['Uguale', 'Maggiore','Minore','Periodo'];

 


const FilterMenuMonitoraggio = ({ anchorEl, open, handleClose, handleAdd, handleRemove,handleRemoveAndClearAll, handleFiltra, handleDownloadExcel, 
    handleSelectChangeColumn1,handleSelectChangeColumn2,handleSelectChangeColumn3,handleSelectChangeColumn4,
    handleSelectChangeColumn5,handleSelectChangeColumn6,handleSelectChangeColumn7,
    handleSelectChangeColumn8,handleSelectChangeColumn9,handleSelectChangeColumn10,handleSelectChangeColumn11,handleSelectChangeColumn12, 
    
    handleSelectChangeStato, handleSelectChangeEsito,handleSelectChangeEsitoMonitoraggio,handleSelectChangeLivelloRischio, 
    handleSelectGestore, handleChangeNDG,handleChangeGiorni, handleChangeCF, handleChangeRagioneSociale,handleChangeInSofferenza,
    handleDateChangePraticaDa, handleDateChangePraticaA,handleDateChangeStatusDa,handleDateChangeStatusA, 
    handleDateTextSearch,handleDateStatusTextSearch, handleSelectSelectSearchStato, handleSelectSelectSearchEsito, handleSelectSelectSearchEsitoMonitoraggio,handleSelectSelectSearchLivelloRischio,
    handleSelectChangeInSofferenza,
    handleSelectTextSearchGestore, handleSelectTextSearchNdg,handleSelectTextSearchGiorni, handleSelectTextSearchCf, handleSelectTextSearchRagSociale,

     count, cell1, cell2, cell3, cell4, cell5, cell6, cell7,cell8,cell9,cell10,cell11,cell12, cellNames,
      isStatoEnabled, 
     selectSearchingStato, stato, esito,esitoM,livelloRischio, gestore,inSofferenza, selectSearchingEsito, selectSearchingEsitoMonitoraggio,selectSearchingLivelloRischio,
     selectInSofferenza,

     ndg,giorni, cf, ragioneSociale, dateSearching,dateSearchingStatus,textSearchingRagSociale,textSearchingNdg,textSearchingGiorni,textSearchingCf,
     selectGestore,
     dataPraticaDa, dataPraticaA,dataStatusDa,dataStatusA, isDataPraticaEnabled,
     handleClearRagioneSociale,handleClearStatoPratica,handleClearCodiceFiscale,handleClearNdg,handleClearGiorni,handleClearGestore,handleClearDataPraticaDa,handleClearEsitoSintetico,handleClearEsitoMonitoraggio,handleClearLivelloRischio,handleClearDataPraticaA,handleClearDataStatusDa,handleClearDataStatusA,
     handleClearInSofferenza,isFiltering,resetToInitialList}
    
    
    ) => {
      const [elements, setElements] = useState([]);
      const [loading, setLoading] = useState(true);
      const [livelloDiRischio, setLivelloDiRischio] = useState([]);
      const [statiList, setStatiList] = useState([]);

      const [utentiAssegnatari, setUtentiAssegnatari] = useState([]);
      useEffect(() => {
        getAllElement()
          .then(response => {
            setElements(response.data);
            setLoading(false);
            localStorage.setItem('statiList', JSON.stringify(response.data.statiList));
            localStorage.setItem('livelliDiRischioList', JSON.stringify(response.data.livelliDiRischioList));
            setStatiList(response.data.statiList);  // Aggiungi questa linea
            setLivelloDiRischio(response.data.livelliDiRischioList);  // Aggiungi questa linea
          })
          .catch(error => {
            console.error("There was an error fetching the elements!", error);
            setLoading(false);
          });
      }, []);
    
      useEffect(() => {
        setLivelloDiRischio(JSON.parse(localStorage.getItem('livelliDiRischioList')));
        setStatiList(JSON.parse(localStorage.getItem('statiList')));
      }, [elements]);
      useEffect(() => {
        //if(utentiAssegnatari === null){
          getListaUtenzeAssegnatariMonitoraggio(true)
            .then(response => {
              debugger
              const utentiMonitoraggio = response;
              localStorage.setItem('DaAssegnareMonitoraggio', JSON.stringify(utentiMonitoraggio));
              setUtentiAssegnatari(utentiMonitoraggio);
            })
            .catch(error => {
              console.error('Error fetching data:', error);
            });
       // }

      }, []);
      

    return (
      <Menu
        id="basic-menu"
        sx={{ width: '100%', marginTop: '-100px' }} // Regola il valore di marginTop in base alle tue esigenze
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right', // o 'left' per aprire a sinistra
        }}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
  <div>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleAdd}
      disabled={count === 11}
      title="Aggiungi Filtro"
    >
      <AddIcon></AddIcon>
    </IconButton>
    <span></span>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleRemove}
      disabled={count === 0}
      title="Rimuovi Filtro"
    >
      <RemoveIcon></RemoveIcon>
    </IconButton>
    <span></span>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={resetToInitialList}
      disabled={count === 0}
      title="Annulla Filtraggio"
    >
     <CancelIcon></CancelIcon>
    </IconButton>
  </div>

  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleFiltra}
      title='Cerca'
    >
      <SearchIcon></SearchIcon>
    </IconButton>

    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleDownloadExcel}
      disabled={!isFiltering}
      title="Download Excel"
    >
      <FileDownloadIcon></FileDownloadIcon>
    </IconButton>
  </div>
</div>
<div style={{margin:'10px'}}>
{count >= 1 &&(
        <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
          
          <Select
  name='optSelect'
  value={cell1}
  onChange={handleSelectChangeColumn1}
  sx={{ width: '190px', height: '30px'}}
>
  {count === 1
    ? cellNames.map((opzione, index) => (
        <MenuItem key={index} value={opzione}>
          {opzione}
        </MenuItem>
      ))
    : cellNames
    .filter(opzione => [cell2, cell3, cell4, cell5, cell6, cell7,cell8,cell9,cell10,cell11,cell12].every(cell => cell !== opzione))
        .map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
</Select>



{cell1 === cellNames[6] && (
  
  <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
      name='statoSearching'
      value={selectSearchingStato}
      onChange={handleSelectSelectSearchStato}
      sx={{ width: '190px', height: '30px' }}

    >
     {selectTypeSearch.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <Select
      name='statoPraticaValue'
      value={stato}
      onChange={handleSelectChangeStato}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
      {statiList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearStatoPratica}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>
    </div>
  )}

{cell1 === cellNames[4] && (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
    <Select
      name='dateSearching'
      value={dateSearching}
      onChange={handleDateTextSearch}
      sx={{ width: '190px', height: '30px' }}
    >
      {dateTypeSearch.map((opzione, index) => (
        <MenuItem key={index} value={opzione}>
          {opzione}
        </MenuItem>
      ))}
    </Select>
    
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>
    
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
    <DatePicker
      value={dataPraticaDa}
      onChange={handleDateChangePraticaDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataPraticaDa && (
                  <IconButton onClick={handleClearDataPraticaDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
      disabled={!isDataPraticaEnabled}
    />

      
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>

      {dateSearching === "Periodo" && (
        <DatePicker
        value={dataPraticaA}
        onChange={handleDateChangePraticaA}
        renderInput={(props) => (
          <TextField
            {...props}
            label="A"
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  
                  {dataPraticaA && (
                    <IconButton onClick={handleClearDataPraticaA} sx={{ marginRight: '-25px' }}> 
                      <CancelIcon />
                    </IconButton>
                  )}
                  {props.InputProps.endAdornment}
                </InputAdornment>
              ),
            }}
            sx={{
              width: '190px',
              paddingRight: 0,
              paddingBottom: 3,
              '& .MuiSvgIcon-root': {
                marginRight: '5px',
              },
              '& .MuiInputBase-root': {
                border: '1px solid #ced4da',
                borderRadius: '4px',
              },
            }}
          />
        )}
        format="DD/MM/YYYY"
        sx={{ flexGrow:1}}
        disabled={!isDataPraticaEnabled}
      />
      )}
      </div>
    </LocalizationProvider>
    </div>

  </div>
)}

{cell1 === cellNames[5] && (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
    <Select
      name='dateSearching'
      value={dateSearchingStatus}
      onChange={handleDateStatusTextSearch}
      sx={{ width: '190px', height: '30px' }}
    >
      {dateTypeSearch.map((opzione, index) => (
        <MenuItem key={index} value={opzione}>
          {opzione}
        </MenuItem>
      ))}
    </Select>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>

    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
    <DatePicker
      value={dataStatusDa}
      onChange={handleDateChangeStatusDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataStatusDa && (
                  <IconButton onClick={handleClearDataStatusDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
    />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>

      {dateSearchingStatus === "Periodo" && (
        <DatePicker
        value={dataStatusA}
        onChange={handleDateChangeStatusA}
        renderInput={(props) => (
          <TextField
            {...props}
            label="A"
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  
                  {dataStatusA && (
                    <IconButton onClick={handleClearDataStatusA} sx={{ marginRight: '-25px' }}> 
                      <CancelIcon />
                    </IconButton>
                  )}
                  {props.InputProps.endAdornment}
                </InputAdornment>
              ),
            }}
            sx={{
              width: '190px',
              paddingRight: 0,
              paddingBottom: 3,
              '& .MuiSvgIcon-root': {
                marginRight: '5px',
              },
              '& .MuiInputBase-root': {
                border: '1px solid #ced4da',
                borderRadius: '4px',
              },
            }}
          />
        )}
        format="DD/MM/YYYY"
        sx={{ flexGrow: 1 }}
      />
      )}
      </div>
    </LocalizationProvider>
    </div>

  </div>
)}


  {cell1 === cellNames[7] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='esitoSearching'
          value={selectSearchingEsito}
          onChange={handleSelectSelectSearchEsito}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='esitoInserimentoValue'
      value={esito}
      onChange={handleSelectChangeEsito}
      sx={{ width: '190px', height: '30px' }}

    >
     {esitoSintetico.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoSintetico}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell1 === cellNames[9] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='esitoMonitoraggioSearching'
          value={selectSearchingEsitoMonitoraggio}
          onChange={handleSelectSelectSearchEsitoMonitoraggio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='esitoInserimentoValue'
      value={esitoM}
      onChange={handleSelectChangeEsitoMonitoraggio}
      sx={{ width: '190px', height: '30px' }}

    >
     {esitoMonitoraggioFondi.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoMonitoraggio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell1 === cellNames[10] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='livelloRischioSearching'
          value={selectSearchingLivelloRischio}
          onChange={handleSelectSelectSearchLivelloRischio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='livelloRischioInserimentoValue'
      value={livelloRischio}
      onChange={handleSelectChangeLivelloRischio}
      sx={{ width: '190px', height: '30px' }}

    >
     {livelloDiRischio.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={() => {
        console.log('IconButton clicked');
        handleClearLivelloRischio();
      }}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell1 === cellNames[11] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='inSofferenzaSearching'
          value={selectInSofferenza}
          onChange={handleChangeInSofferenza}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='inSofforenzaValue'
      value={inSofferenza}
      onChange={handleSelectChangeInSofferenza}
      sx={{ width: '190px', height: '30px' }}

    >
     {inSofferenzaList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={() => {
        console.log('IconButton clicked');
        handleClearInSofferenza();
      }}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell1 === cellNames[3] && (
 <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='gestoreSearching'
          value={selectGestore}
          onChange={handleSelectTextSearchGestore}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
        <Select
      name='gestoreValue'
      value={gestore}
      onChange={handleSelectGestore}
      sx={{ width: '190px', height: '30px' }}

    >
     {gestoreList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGestore}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>
    </div>

  )}



  {cell1 === cellNames[0] && (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='ndgSearching'
          value={textSearchingNdg}
          onChange={handleSelectTextSearchNdg}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
  <TextField
    margin="normal"
    placeholder=""
    required
    fullWidth
    value={ndg}
    variant="standard"
    helperText=""
    id="search"
    name="search"
    autoComplete="search"
    onChange={handleChangeNDG}
    autoFocus
    sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
  />
  <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearNdg}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>
  </div>
  )}
  {cell1 === cellNames[1] && (
       <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
      <Select
          name='cfSearching'
          value={textSearchingCf}
          onChange={handleSelectTextSearchCf}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={cf}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeCF}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}     

   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearCodiceFiscale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>
   </div>
  )}
  {cell1 === cellNames[2] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
       <Select
          name='ragioneSocialeSearching'
          value={textSearchingRagSociale}
          onChange={handleSelectTextSearchRagSociale}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={ragioneSociale}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeRagioneSociale}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearRagioneSociale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>

   
   
   
</div>

  )}
  {cell1 === cellNames[8] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
       <Select
          name='giorniSearching'
          value={textSearchingGiorni}
          onChange={handleSelectTextSearchGiorni}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={giorni}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeGiorni}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', 
      padding: 0, 
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', 
        borderRadius: '4px', 
      },
      marginTop: '5px', 
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGiorni}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>

   
   
   
</div>

  )}

</div>
)}
{count >= 2 &&(
<div style={{ display: 'flex', flexDirection: 'row', alignItems:'center'}}>
  
  <Select
    name='optSelect'
    value={cell2}
    onChange={handleSelectChangeColumn2}
    sx={{ width: '190px', height: '30px' }}
  >
    {cellNames.filter(opzione => opzione !== cell1)

    .map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
  </Select>

 
  {cell2 === cellNames[6] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='statoSearching'
          value={selectSearchingStato}
          onChange={handleSelectSelectSearchStato}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='statoPraticaValue'
      value={stato}
      onChange={handleSelectChangeStato}
      sx={{ width: '190px', height: '30px'}}
      disabled={!isStatoEnabled}
    >
      {statiList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearStatoPratica}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>
    </div>
  )
  }
  {cell2 === cellNames[4] && (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
  <Select
    name='dateSearching'
    value={dateSearching}
    onChange={handleDateTextSearch}
    sx={{ width: '190px', height: '30px' }}
  >
    {dateTypeSearch.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
  </Select>
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>

  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
  <DatePicker
      value={dataPraticaDa}
      onChange={handleDateChangePraticaDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                {dataPraticaDa && (
                  <IconButton onClick={handleClearDataPraticaDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
      disabled={!isDataPraticaEnabled}
    />
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>

    {dateSearching === "Periodo" && (
      <DatePicker
      value={dataPraticaA}
      onChange={handleDateChangePraticaA}
      renderInput={(props) => (
        <TextField
          {...props}
          label="A"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                {dataPraticaA && (
                  <IconButton onClick={handleClearDataPraticaA} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ width: '50%' }}
      disabled={!isDataPraticaEnabled}
    />
    )}
    </div>
  </LocalizationProvider>
  </div>

</div>
)}
{cell2 === cellNames[5] && (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
    <Select
      name='dateSearching'
      value={dateSearchingStatus}
      onChange={handleDateStatusTextSearch}
      sx={{ width: '190px', height: '30px' }}
    >
      {dateTypeSearch.map((opzione, index) => (
        <MenuItem key={index} value={opzione}>
          {opzione}
        </MenuItem>
      ))}
    </Select>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>

    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
    <DatePicker
      value={dataStatusDa}
      onChange={handleDateChangeStatusDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                {dataStatusDa && (
                  <IconButton onClick={handleClearDataStatusDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
    />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>

      {dateSearchingStatus === "Periodo" && (
        <DatePicker
        value={dataStatusA}
        onChange={handleDateChangeStatusA}
        renderInput={(props) => (
          <TextField
            {...props}
            label="A"
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  {dataStatusA && (
                    <IconButton onClick={handleClearDataStatusA} sx={{ marginRight: '-25px' }}> 
                      <CancelIcon />
                    </IconButton>
                  )}
                  {props.InputProps.endAdornment}
                </InputAdornment>
              ),
            }}
            sx={{
              width: '190px',
              paddingRight: 0,
              paddingBottom: 3,
              '& .MuiSvgIcon-root': {
                marginRight: '5px',
              },
              '& .MuiInputBase-root': {
                border: '1px solid #ced4da',
                borderRadius: '4px',
              },
            }}
          />
        )}
        format="DD/MM/YYYY"
        sx={{ flexGrow: 1 }}
      />
      )}
      </div>
    </LocalizationProvider>
    </div>

  </div>
)}
  {cell2 === cellNames[7] && (
 <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
 <Select
       name='esitoSearching'
       value={selectSearchingEsito}
       onChange={handleSelectSelectSearchEsito}
       sx={{ width: '190px', height: '30px' }}
     >
      {selectTypeSearch.map((opzione, index) => (
       <MenuItem key={index} value={opzione}>
         {opzione}
       </MenuItem>
     ))}
     </Select>
    <Select
      name='esitoSinteticoValue'
      value={esito}
      onChange={handleSelectChangeEsito}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
     {esitoSintetico.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoSintetico}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>


  )}
  {cell2 === cellNames[9] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='esitoMonitoraggioSearching'
          value={selectSearchingEsitoMonitoraggio}
          onChange={handleSelectSelectSearchEsitoMonitoraggio}
          sx={{ width: '190px', height: '30px' }}
        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='esitoInserimentoValue'
      value={esitoM}
      onChange={handleSelectChangeEsitoMonitoraggio}
      sx={{ width: '190px', height: '30px' }}
    >
     {esitoMonitoraggioFondi.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoMonitoraggio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell2 === cellNames[10] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='livelloRischioSearching'
          value={selectSearchingLivelloRischio}
          onChange={handleSelectSelectSearchLivelloRischio}
          sx={{ width: '190px', height: '30px' }}
        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='livelloRischioInserimentoValue'
      value={livelloRischio}
      onChange={handleSelectChangeLivelloRischio}
      sx={{ width: '190px', height: '30px' }}

    >
     {livelloDiRischio.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearLivelloRischio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell2 === cellNames[11] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='inSofferenzaSearching'
          value={selectInSofferenza}
          onChange={handleChangeInSofferenza}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='inSofforenzaValue'
      value={inSofferenza}
      onChange={handleSelectChangeInSofferenza}
      sx={{ width: '190px', height: '30px' }}

    >
     {inSofferenzaList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={() => {
        console.log('IconButton clicked');
        handleClearInSofferenza();
      }}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell2 === cellNames[3] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
          name='gestoreSearching'
          value={selectGestore}
          onChange={handleSelectTextSearchGestore}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
        <Select
      name='gestoreValue'
      value={gestore}
      onChange={handleSelectGestore}
      sx={{ width: '190px', height: '30px' }}

    >
     {gestoreList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGestore}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}



  {cell2 === cellNames[0] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start',}}>
<Select
          name='ndgSearching'
          value={textSearchingNdg}
          onChange={handleSelectTextSearchNdg}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <TextField
    margin="normal"
    placeholder=""
    required
    fullWidth
    value={ndg}
    variant="standard"
    helperText=""
    id="search"
    name="search"
    autoComplete="search"
    onChange={handleChangeNDG}
    autoFocus
    sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
  />
  <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearNdg}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>
  </div>
  )}
  {cell2 === cellNames[1] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
<Select
          name='cfSearching'
          value={textSearchingCf}
          onChange={handleSelectTextSearchCf}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={cf}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeCF}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}     

   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearCodiceFiscale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>
   </div>
  )}
  {cell2 === cellNames[2] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='ragioneSocialeSearching'
          value={textSearchingRagSociale}
          onChange={handleSelectTextSearchRagSociale}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={ragioneSociale}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeRagioneSociale}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearRagioneSociale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>
   </div>
  )}
{cell2 === cellNames[8] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
       <Select
          name='giorniSearching'
          value={textSearchingGiorni}
          onChange={handleSelectTextSearchGiorni}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={giorni}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeGiorni}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', 
      padding: 0, 
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', 
        borderRadius: '4px', 
      },
      marginTop: '5px', 
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGiorni}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>

   
   
   
</div>

  )}
  
  
</div>
)}
{count >= 3 &&(
<div style={{ display: 'flex', flexDirection: 'row', alignItems:'center',marginTop:'10px' }}>
  
  <Select
    name='optSelect'
    value={cell3}
    onChange={handleSelectChangeColumn3}
    sx={{ width: '190px', height: '30px' }}
  >
    {cellNames.filter(opzione => opzione !== cell1 && opzione !== cell2)

    .map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
  </Select>

 
  {cell3 === cellNames[6] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
      name='statusSearching'
      value={selectSearchingStato}
      onChange={handleSelectSelectSearchStato}
      sx={{ width: '190px', height: '30px' }}

    >
     {selectTypeSearch.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <Select
      name='statoPraticaValue'
      value={stato}
      onChange={handleSelectChangeStato}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
      {statiList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearStatoPratica}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>

  )
  }
  {cell3 === cellNames[4] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
      <Select
        name='dateSearching'
        value={dateSearching}
        onChange={handleDateTextSearch}
        sx={{ width: '190px', height: '30px' }}
      >
        {dateTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
      </Select>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>
  
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
      <DatePicker
      value={dataPraticaDa}
      onChange={handleDateChangePraticaDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataPraticaDa && (
                  <IconButton onClick={handleClearDataPraticaDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
      disabled={!isDataPraticaEnabled}
    />
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
  
        {dateSearching === "Periodo" && (
          <DatePicker
          value={dataPraticaA}
          onChange={handleDateChangePraticaA}
          renderInput={(props) => (
            <TextField
              {...props}
              label="A"
              InputProps={{
                ...props.InputProps,
                endAdornment: (
                  <InputAdornment position="end">
                    
                    {dataPraticaA && (
                      <IconButton onClick={handleClearDataPraticaA} sx={{ marginRight: '-25px' }}> 
                        <CancelIcon />
                      </IconButton>
                    )}
                    {props.InputProps.endAdornment}
                  </InputAdornment>
                ),
              }}
              sx={{
                width: '190px',
                paddingRight: 0,
                paddingBottom: 3,
                '& .MuiSvgIcon-root': {
                  marginRight: '5px',
                },
                '& .MuiInputBase-root': {
                  border: '1px solid #ced4da',
                  borderRadius: '4px',
                },
              }}
            />
          )}
          format="DD/MM/YYYY"
          sx={{ flexGrow:1 }}
          disabled={!isDataPraticaEnabled}
        />
        )}
        </div>
      </LocalizationProvider>
      </div>
  
    </div>
)}
{cell3 === cellNames[5] && (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
    <Select
      name='dateSearching'
      value={dateSearchingStatus}
      onChange={handleDateStatusTextSearch}
      sx={{ width: '190px', height: '30px' }}
    >
      {dateTypeSearch.map((opzione, index) => (
        <MenuItem key={index} value={opzione}>
          {opzione}
        </MenuItem>
      ))}
    </Select>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>

    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
    <DatePicker
      value={dataStatusDa}
      onChange={handleDateChangeStatusDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataStatusDa && (
                  <IconButton onClick={handleClearDataStatusDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
    />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>

      {dateSearchingStatus === "Periodo" && (
        <DatePicker
        value={dataStatusA}
        onChange={handleDateChangeStatusA}
        renderInput={(props) => (
          <TextField
            {...props}
            label="A"
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  
                  {dataStatusA && (
                    <IconButton onClick={handleClearDataStatusA} sx={{ marginRight: '-25px' }}> 
                      <CancelIcon />
                    </IconButton>
                  )}
                  {props.InputProps.endAdornment}
                </InputAdornment>
              ),
            }}
            sx={{
              width: '190px',
              paddingRight: 0,
              paddingBottom: 3,
              '& .MuiSvgIcon-root': {
                marginRight: '5px',
              },
              '& .MuiInputBase-root': {
                border: '1px solid #ced4da',
                borderRadius: '4px',
              },
            }}
          />
        )}
        format="DD/MM/YYYY"
        sx={{ flexGrow: 1 }}
      />
      )}
      </div>
    </LocalizationProvider>
    </div>

  </div>
)}
  {cell3 === cellNames[7] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
           name='esitoSearching'
           value={selectSearchingEsito}
           onChange={handleSelectSelectSearchEsito}
           sx={{ width: '190px', height: '30px' }}

         >
          {selectTypeSearch.map((opzione, index) => (
           <MenuItem key={index} value={opzione}>
             {opzione}
           </MenuItem>
         ))}
         </Select>
    <Select
      name='esitoSinteticoValue'
      value={esito}
      onChange={handleSelectChangeEsito}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
     {esitoSintetico.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoSintetico}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell3 === cellNames[9] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='esitoMonitoraggioSearching'
          value={selectSearchingEsitoMonitoraggio}
          onChange={handleSelectSelectSearchEsitoMonitoraggio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='esitoInserimentoValue'
      value={esitoM}
      onChange={handleSelectChangeEsitoMonitoraggio}
      sx={{ width: '190px', height: '30px' }}

    >
     {esitoMonitoraggioFondi.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoMonitoraggio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell3 === cellNames[10] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='livelloRischioSearching'
          value={selectSearchingLivelloRischio}
          onChange={handleSelectSelectSearchLivelloRischio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='livelloRischioInserimentoValue'
      value={livelloRischio}
      onChange={handleSelectChangeLivelloRischio}
      sx={{ width: '190px', height: '30px' }}

    >
     {livelloDiRischio.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearLivelloRischio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell3 === cellNames[11] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='inSofferenzaSearching'
          value={selectInSofferenza}
          onChange={handleChangeInSofferenza}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='inSofforenzaValue'
      value={inSofferenza}
      onChange={handleSelectChangeInSofferenza}
      sx={{ width: '190px', height: '30px' }}

    >
     {inSofferenzaList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={() => {
        console.log('IconButton clicked');
        handleClearInSofferenza();
      }}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell3 === cellNames[3] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
          name='gestoreSearching'
          value={selectGestore}
          onChange={handleSelectTextSearchGestore}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
        <Select
      name='gestoreValue'
      value={gestore}
      onChange={handleSelectGestore}
      sx={{ width: '190px', height: '30px' }}

    >
     {gestoreList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGestore}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}



  {cell3 === cellNames[0] && (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
<Select
          name='ndgSearching'
          value={textSearchingNdg}
          onChange={handleSelectTextSearchNdg}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <TextField
    margin="normal"
    placeholder=""
    required
    fullWidth
    value={ndg}
    variant="standard"
    helperText=""
    id="search"
    name="search"
    autoComplete="search"
    onChange={handleChangeNDG}
    autoFocus
    sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
  />
  <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearNdg}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell3 === cellNames[1] && (
           <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='cfSearching'
          value={textSearchingCf}
          onChange={handleSelectTextSearchCf}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={cf}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeCF}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}     

   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearCodiceFiscale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell3 === cellNames[2] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
    <Select
              name='ragioneSocialeSearching'
              value={textSearchingRagSociale}
              onChange={handleSelectTextSearchRagSociale}
              sx={{ width: '190px', height: '30px' }}

            >
             {textTypeSearch.map((opzione, index) => (
              <MenuItem key={index} value={opzione}>
                {opzione}
              </MenuItem>
            ))}
            </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={ragioneSociale}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeRagioneSociale}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearRagioneSociale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
{cell3 === cellNames[8] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
       <Select
          name='giorniSearching'
          value={textSearchingGiorni}
          onChange={handleSelectTextSearchGiorni}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={giorni}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeGiorni}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', 
      padding: 0, 
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', 
        borderRadius: '4px', 
      },
      marginTop: '5px', 
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGiorni}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>

   
   
   
</div>

  )}
  
  
</div>
)}
{count >= 4 &&(
<div style={{ display: 'flex', flexDirection: 'row', alignItems:'center',marginTop:'10px' }}>
  
  <Select
    name='optSelect'
    value={cell4}
    onChange={handleSelectChangeColumn4}
    sx={{ width: '190px', height: '30px' }}
  >
    {cellNames.filter(opzione => opzione !== cell1 && opzione !== cell2 && opzione !== cell3)

    .map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
  </Select>

 
  {cell4 === cellNames[6] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='statusSearching'
          value={selectSearchingStato}
          onChange={handleSelectSelectSearchStato}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='statoPraticaValue'
      value={stato}
      onChange={handleSelectChangeStato}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
      {statiList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearStatoPratica}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )
  }
  {cell4 === cellNames[4] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
     <Select
       name='dateSearching'
       value={dateSearching}
       onChange={handleDateTextSearch}
       sx={{ width: '190px', height: '30px' }}
     >
       {dateTypeSearch.map((opzione, index) => (
         <MenuItem key={index} value={opzione}>
           {opzione}
         </MenuItem>
       ))}
     </Select>
     <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>
 
     <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
     <DatePicker
      value={dataPraticaDa}
      onChange={handleDateChangePraticaDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataPraticaDa && (
                  <IconButton onClick={handleClearDataPraticaDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
      disabled={!isDataPraticaEnabled}
    />
           <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
 
       {dateSearching === "Periodo" && (
         <DatePicker
         value={dataPraticaA}
         onChange={handleDateChangePraticaA}
         renderInput={(props) => (
           <TextField
             {...props}
             label="A"
             InputProps={{
               ...props.InputProps,
               endAdornment: (
                 <InputAdornment position="end">
                   
                   {dataPraticaA && (
                     <IconButton onClick={handleClearDataPraticaA} sx={{ marginRight: '-25px' }}> 
                       <CancelIcon />
                     </IconButton>
                   )}
                   {props.InputProps.endAdornment}
                 </InputAdornment>
               ),
             }}
             sx={{
               width: '190px',
               paddingRight: 0,
               paddingBottom: 3,
               '& .MuiSvgIcon-root': {
                 marginRight: '5px',
               },
               '& .MuiInputBase-root': {
                 border: '1px solid #ced4da',
                 borderRadius: '4px',
               },
             }}
           />
         )}
         format="DD/MM/YYYY"
         sx={{ flexGrow:1 }}
         disabled={!isDataPraticaEnabled}
       />
       )}
       </div>
     </LocalizationProvider>
     </div>
 
   </div>

)}
{cell4 === cellNames[5] && (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
    <Select
      name='dateSearching'
      value={dateSearchingStatus}
      onChange={handleDateStatusTextSearch}
      sx={{ width: '190px', height: '30px' }}
    >
      {dateTypeSearch.map((opzione, index) => (
        <MenuItem key={index} value={opzione}>
          {opzione}
        </MenuItem>
      ))}
    </Select>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>

    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
    <DatePicker
      value={dataStatusDa}
      onChange={handleDateChangeStatusDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataStatusDa && (
                  <IconButton onClick={handleClearDataStatusDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
    />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>

      {dateSearchingStatus === "Periodo" && (
        <DatePicker
        value={dataStatusA}
        onChange={handleDateChangeStatusA}
        renderInput={(props) => (
          <TextField
            {...props}
            label="A"
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  
                  {dataStatusA && (
                    <IconButton onClick={handleClearDataStatusA} sx={{ marginRight: '-25px' }}> 
                      <CancelIcon />
                    </IconButton>
                  )}
                  {props.InputProps.endAdornment}
                </InputAdornment>
              ),
            }}
            sx={{
              width: '190px',
              paddingRight: 0,
              paddingBottom: 3,
              '& .MuiSvgIcon-root': {
                marginRight: '5px',
              },
              '& .MuiInputBase-root': {
                border: '1px solid #ced4da',
                borderRadius: '4px',
              },
            }}
          />
        )}
        format="DD/MM/YYYY"
        sx={{ flexGrow: 1 }}
      />
      )}
      </div>
    </LocalizationProvider>
    </div>

  </div>
)}
  {cell4 === cellNames[7] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
           name='esitoSearching'
           value={selectSearchingEsito}
           onChange={handleSelectSelectSearchEsito}
           sx={{ width: '190px', height: '30px' }}

         >
          {selectTypeSearch.map((opzione, index) => (
           <MenuItem key={index} value={opzione}>
             {opzione}
           </MenuItem>
         ))}
         </Select>
    <Select
      name='esitoSinteticoValue'
      value={esito}
      onChange={handleSelectChangeEsito}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
     {esitoSintetico.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoSintetico}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell4 === cellNames[9] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='esitoMonitoraggioSearching'
          value={selectSearchingEsitoMonitoraggio}
          onChange={handleSelectSelectSearchEsitoMonitoraggio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='esitoInserimentoValue'
      value={esitoM}
      onChange={handleSelectChangeEsitoMonitoraggio}
      sx={{ width: '190px', height: '30px' }}

    >
     {esitoMonitoraggioFondi.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoMonitoraggio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell4 === cellNames[10] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='livelloRischioSearching'
          value={selectSearchingLivelloRischio}
          onChange={handleSelectSelectSearchLivelloRischio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='livelloRischioInserimentoValue'
      value={livelloRischio}
      onChange={handleSelectChangeLivelloRischio}
      sx={{ width: '190px', height: '30px' }}

    >
     {livelloDiRischio.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearLivelloRischio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell4 === cellNames[11] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='inSofferenzaSearching'
          value={selectInSofferenza}
          onChange={handleChangeInSofferenza}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='inSofforenzaValue'
      value={inSofferenza}
      onChange={handleSelectChangeInSofferenza}
      sx={{ width: '190px', height: '30px' }}

    >
     {inSofferenzaList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={() => {
        console.log('IconButton clicked');
        handleClearInSofferenza();
      }}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell4 === cellNames[3] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
          name='gestoreSearching'
          value={selectGestore}
          onChange={handleSelectTextSearchGestore}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
        <Select
      name='gestoreValue'
      value={gestore}
      onChange={handleSelectGestore}
      sx={{ width: '190px', height: '30px' }}

    >
     {gestoreList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGestore}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}



  {cell4 === cellNames[0] && (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
<Select
          name='ndgSearching'
          value={textSearchingNdg}
          onChange={handleSelectTextSearchNdg}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <TextField
    margin="normal"
    placeholder=""
    required
    fullWidth
    value={ndg}
    variant="standard"
    helperText=""
    id="search"
    name="search"
    autoComplete="search"
    onChange={handleChangeNDG}
    autoFocus
    sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
  />
  <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearNdg}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell4 === cellNames[1] && (
           <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='cfSearching'
          value={textSearchingCf}
          onChange={handleSelectTextSearchCf}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={cf}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeCF}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}     

   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearCodiceFiscale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>
   </div>
  )}
  {cell4 === cellNames[2] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
    <Select
              name='ragioneSocialeSearching'
              value={textSearchingRagSociale}
              onChange={handleSelectTextSearchRagSociale}
              sx={{ width: '190px', height: '30px' }}

            >
             {textTypeSearch.map((opzione, index) => (
              <MenuItem key={index} value={opzione}>
                {opzione}
              </MenuItem>
            ))}
            </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={ragioneSociale}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeRagioneSociale}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearRagioneSociale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
{cell4 === cellNames[8] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
       <Select
          name='giorniSearching'
          value={textSearchingGiorni}
          onChange={handleSelectTextSearchGiorni}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={giorni}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeGiorni}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', 
      padding: 0, 
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', 
        borderRadius: '4px', 
      },
      marginTop: '5px', 
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGiorni}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>

   
   
   
</div>

  )}
  
  
</div>
)}
{count >= 5 &&(
<div style={{ display: 'flex', flexDirection: 'row', alignItems:'center',marginTop:'10px' }}>
  
  <Select
    name='optSelect'
    value={cell5}
    onChange={handleSelectChangeColumn5}
    sx={{ width: '190px', height: '30px' }}
  >
    {cellNames.filter(opzione => opzione !== cell1 && opzione !== cell2 && opzione !== cell3 && opzione !== cell4)
    .map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
  </Select>

 
  {cell5 === cellNames[6] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='statusSearching'
          value={selectSearchingStato}
          onChange={handleSelectSelectSearchStato}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='statoPraticaValue'
      value={stato}
      onChange={handleSelectChangeStato}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
     {statiList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearStatoPratica}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )
  }
  {cell5 === cellNames[4] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
     <Select
       name='dateSearching'
       value={dateSearching}
       onChange={handleDateTextSearch}
       sx={{ width: '190px', height: '30px' }}
     >
       {dateTypeSearch.map((opzione, index) => (
         <MenuItem key={index} value={opzione}>
           {opzione}
         </MenuItem>
       ))}
     </Select>
     <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>
 
     <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
     <DatePicker
      value={dataPraticaDa}
      onChange={handleDateChangePraticaDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataPraticaDa && (
                  <IconButton onClick={handleClearDataPraticaDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
      disabled={!isDataPraticaEnabled}
    />
           <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
 
       {dateSearching === "Periodo" && (
         <DatePicker
         value={dataPraticaA}
         onChange={handleDateChangePraticaA}
         renderInput={(props) => (
           <TextField
             {...props}
             label="A"
             InputProps={{
               ...props.InputProps,
               endAdornment: (
                 <InputAdornment position="end">
                   
                   {dataPraticaA && (
                     <IconButton onClick={handleClearDataPraticaA} sx={{ marginRight: '-25px' }}> 
                       <CancelIcon />
                     </IconButton>
                   )}
                   {props.InputProps.endAdornment}
                 </InputAdornment>
               ),
             }}
             sx={{
               width: '190px',
               paddingRight: 0,
               paddingBottom: 3,
               '& .MuiSvgIcon-root': {
                 marginRight: '5px',
               },
               '& .MuiInputBase-root': {
                 border: '1px solid #ced4da',
                 borderRadius: '4px',
               },
             }}
           />
         )}
         format="DD/MM/YYYY"
         sx={{ flexGrow:1 }}
         disabled={!isDataPraticaEnabled}
       />
       )}
       </div>
     </LocalizationProvider>
     </div>
 
   </div>

)}
{cell5 === cellNames[5] && (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
    <Select
      name='dateSearching'
      value={dateSearchingStatus}
      onChange={handleDateStatusTextSearch}
      sx={{ width: '190px', height: '30px' }}
    >
      {dateTypeSearch.map((opzione, index) => (
        <MenuItem key={index} value={opzione}>
          {opzione}
        </MenuItem>
      ))}
    </Select>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>

    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
    <DatePicker
      value={dataStatusDa}
      onChange={handleDateChangeStatusDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataStatusDa && (
                  <IconButton onClick={handleClearDataStatusDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
    />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>

      {dateSearchingStatus === "Periodo" && (
       <DatePicker
       value={dataStatusA}
       onChange={handleDateChangeStatusA}
       renderInput={(props) => (
         <TextField
           {...props}
           label="A"
           InputProps={{
             ...props.InputProps,
             endAdornment: (
               <InputAdornment position="end">
                 
                 {dataStatusA && (
                   <IconButton onClick={handleClearDataStatusA} sx={{ marginRight: '-25px' }}> 
                     <CancelIcon />
                   </IconButton>
                 )}
                 {props.InputProps.endAdornment}
               </InputAdornment>
             ),
           }}
           sx={{
             width: '190px',
             paddingRight: 0,
             paddingBottom: 3,
             '& .MuiSvgIcon-root': {
               marginRight: '5px',
             },
             '& .MuiInputBase-root': {
               border: '1px solid #ced4da',
               borderRadius: '4px',
             },
           }}
         />
       )}
       format="DD/MM/YYYY"
       sx={{ flexGrow: 1 }}
     />
      )}
      </div>
    </LocalizationProvider>
    </div>

  </div>
)}
  {cell5 === cellNames[7] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
           name='esitoSearching'
           value={selectSearchingEsito}
           onChange={handleSelectSelectSearchEsito}
           sx={{ width: '190px', height: '30px' }}

         >
          {selectTypeSearch.map((opzione, index) => (
           <MenuItem key={index} value={opzione}>
             {opzione}
           </MenuItem>
         ))}
         </Select>
    <Select
      name='esitoSinteticoValue'
      value={esito}
      onChange={handleSelectChangeEsito}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
     {esitoSintetico.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoSintetico}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell5 === cellNames[9] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='esitoMonitoraggioSearching'
          value={selectSearchingEsitoMonitoraggio}
          onChange={handleSelectSelectSearchEsitoMonitoraggio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='esitoInserimentoValue'
      value={esitoM}
      onChange={handleSelectChangeEsitoMonitoraggio}
      sx={{ width: '190px', height: '30px' }}

    >
     {esitoMonitoraggioFondi.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoMonitoraggio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell5 === cellNames[10] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='livelloRischioSearching'
          value={selectSearchingLivelloRischio}
          onChange={handleSelectSelectSearchLivelloRischio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='livelloRischioInserimentoValue'
      value={livelloRischio}
      onChange={handleSelectChangeLivelloRischio}
      sx={{ width: '190px', height: '30px' }}

    >
     {livelloDiRischio.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearLivelloRischio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell5 === cellNames[11] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='inSofferenzaSearching'
          value={selectInSofferenza}
          onChange={handleChangeInSofferenza}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='inSofforenzaValue'
      value={inSofferenza}
      onChange={handleSelectChangeInSofferenza}
      sx={{ width: '190px', height: '30px' }}

    >
     {inSofferenzaList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={() => {
        console.log('IconButton clicked');
        handleClearInSofferenza();
      }}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell5 === cellNames[3] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
          name='gestoreSearching'
          value={selectGestore}
          onChange={handleSelectTextSearchGestore}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
        <Select
      name='gestoreValue'
      value={gestore}
      onChange={handleSelectGestore}
      sx={{ width: '190px', height: '30px' }}

    >
     {gestoreList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGestore}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}



  {cell5 === cellNames[0] && (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
<Select
          name='ndgSearching'
          value={textSearchingNdg}
          onChange={handleSelectTextSearchNdg}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <TextField
    margin="normal"
    placeholder=""
    required
    fullWidth
    value={ndg}
    variant="standard"
    helperText=""
    id="search"
    name="search"
    autoComplete="search"
    onChange={handleChangeNDG}
    autoFocus
    sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
  />
  <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearNdg}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell5 === cellNames[1] && (
               <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='cfSearching'
          value={textSearchingCf}
          onChange={handleSelectTextSearchCf}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={cf}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeCF}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}     

   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearCodiceFiscale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell5 === cellNames[2] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
    <Select
              name='ragioneSocialeSearching'
              value={textSearchingRagSociale}
              onChange={handleSelectTextSearchRagSociale}
              sx={{ width: '190px', height: '30px' }}

            >
             {textTypeSearch.map((opzione, index) => (
              <MenuItem key={index} value={opzione}>
                {opzione}
              </MenuItem>
            ))}
            </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={ragioneSociale}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeRagioneSociale}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearRagioneSociale}
      title="Pulisci"
      >
        <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
{cell5 === cellNames[8] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
       <Select
          name='giorniSearching'
          value={textSearchingGiorni}
          onChange={handleSelectTextSearchGiorni}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={giorni}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeGiorni}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', 
      padding: 0, 
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', 
        borderRadius: '4px', 
      },
      marginTop: '5px', 
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGiorni}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>

   
   
   
</div>

  )}
  
  
</div>
)}
{count >= 6 &&(
<div style={{ display: 'flex', flexDirection: 'row', alignItems:'center',marginTop:'10px' }}>
  
  <Select
    name='optSelect'
    value={cell6}
    onChange={handleSelectChangeColumn6}
    sx={{ width: '190px', height: '30px' }}
  >
    {cellNames.filter(opzione => opzione !== cell1 && opzione !== cell2 && opzione !== cell3 && opzione !== cell4 && opzione !== cell5 )
    .map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
  </Select>

 
  {cell6 === cellNames[6] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='statusSearching'
          value={selectSearchingStato}
          onChange={handleSelectSelectSearchStato}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='statoPraticaValue'
      value={stato}
      onChange={handleSelectChangeStato}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
      {statiList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearStatoPratica}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )
  }
  {cell6 === cellNames[4] && (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
        <Select
          name='dateSearching'
          value={dateSearching}
          onChange={handleDateTextSearch}
          sx={{ width: '190px', height: '30px' }}
        >
          {dateTypeSearch.map((opzione, index) => (
            <MenuItem key={index} value={opzione}>
              {opzione}
            </MenuItem>
          ))}
        </Select>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>
    
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
        <DatePicker
      value={dataPraticaDa}
      onChange={handleDateChangePraticaDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataPraticaDa && (
                  <IconButton onClick={handleClearDataPraticaDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
      disabled={!isDataPraticaEnabled}
    />
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
    
          {dateSearching === "Periodo" && (
            <DatePicker
            value={dataPraticaA}
            onChange={handleDateChangePraticaA}
            renderInput={(props) => (
              <TextField
                {...props}
                label="A"
                InputProps={{
                  ...props.InputProps,
                  endAdornment: (
                    <InputAdornment position="end">
                      
                      {dataPraticaA && (
                        <IconButton onClick={handleClearDataPraticaA} sx={{ marginRight: '-25px' }}> 
                          <CancelIcon />
                        </IconButton>
                      )}
                      {props.InputProps.endAdornment}
                    </InputAdornment>
                  ),
                }}
                sx={{
                  width: '190px',
                  paddingRight: 0,
                  paddingBottom: 3,
                  '& .MuiSvgIcon-root': {
                    marginRight: '5px',
                  },
                  '& .MuiInputBase-root': {
                    border: '1px solid #ced4da',
                    borderRadius: '4px',
                  },
                }}
              />
            )}
            format="DD/MM/YYYY"
            sx={{ flexGrow:1 }}
            disabled={!isDataPraticaEnabled}
          />
          )}
          </div>
        </LocalizationProvider>
        </div>
    
      </div>

)}
{cell6 === cellNames[5] && (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
    <Select
      name='dateSearching'
      value={dateSearchingStatus}
      onChange={handleDateStatusTextSearch}
      sx={{ width: '190px', height: '30px' }}
    >
      {dateTypeSearch.map((opzione, index) => (
        <MenuItem key={index} value={opzione}>
          {opzione}
        </MenuItem>
      ))}
    </Select>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>

    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
    <DatePicker
      value={dataStatusDa}
      onChange={handleDateChangeStatusDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataStatusDa && (
                  <IconButton onClick={handleClearDataStatusDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
    />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>

      {dateSearchingStatus === "Periodo" && (
        <DatePicker
        value={dataStatusA}
        onChange={handleDateChangeStatusA}
        renderInput={(props) => (
          <TextField
            {...props}
            label="A"
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  
                  {dataStatusA && (
                    <IconButton onClick={handleClearDataStatusA} sx={{ marginRight: '-25px' }}> 
                      <CancelIcon />
                    </IconButton>
                  )}
                  {props.InputProps.endAdornment}
                </InputAdornment>
              ),
            }}
            sx={{
              width: '190px',
              paddingRight: 0,
              paddingBottom: 3,
              '& .MuiSvgIcon-root': {
                marginRight: '5px',
              },
              '& .MuiInputBase-root': {
                border: '1px solid #ced4da',
                borderRadius: '4px',
              },
            }}
          />
        )}
        format="DD/MM/YYYY"
        sx={{ flexGrow: 1 }}
      />
      )}
      </div>
    </LocalizationProvider>
    </div>

  </div>
)}
  {cell6 === cellNames[7] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
           name='esitoSearching'
           value={selectSearchingEsito}
           onChange={handleSelectSelectSearchEsito}
           sx={{ width: '190px', height: '30px' }}

         >
          {selectTypeSearch.map((opzione, index) => (
           <MenuItem key={index} value={opzione}>
             {opzione}
           </MenuItem>
         ))}
         </Select>
    <Select
      name='esitoSinteticoValue'
      value={esito}
      onChange={handleSelectChangeEsito}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
     {esitoSintetico.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoSintetico}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell6 === cellNames[9] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='esitoMonitoraggioSearching'
          value={selectSearchingEsitoMonitoraggio}
          onChange={handleSelectSelectSearchEsitoMonitoraggio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='esitoInserimentoValue'
      value={esitoM}
      onChange={handleSelectChangeEsitoMonitoraggio}
      sx={{ width: '190px', height: '30px' }}

    >
     {esitoMonitoraggioFondi.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoMonitoraggio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell6 === cellNames[10] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='livelloRischioSearching'
          value={selectSearchingLivelloRischio}
          onChange={handleSelectSelectSearchLivelloRischio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='livelloRischioInserimentoValue'
      value={livelloRischio}
      onChange={handleSelectChangeLivelloRischio}
      sx={{ width: '190px', height: '30px' }}

    >
     {livelloDiRischio.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearLivelloRischio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell6 === cellNames[11] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='inSofferenzaSearching'
          value={selectInSofferenza}
          onChange={handleChangeInSofferenza}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='inSofforenzaValue'
      value={inSofferenza}
      onChange={handleSelectChangeInSofferenza}
      sx={{ width: '190px', height: '30px' }}

    >
     {inSofferenzaList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={() => {
        console.log('IconButton clicked');
        handleClearInSofferenza();
      }}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell6 === cellNames[3] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
          name='gestoreSearching'
          value={selectGestore}
          onChange={handleSelectTextSearchGestore}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
        <Select
      name='gestoreValue'
      value={gestore}
      onChange={handleSelectGestore}
      sx={{ width: '190px', height: '30px' }}

    >
     {gestoreList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGestore}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}



  {cell6 === cellNames[0] && (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
<Select
          name='ndgSearching'
          value={textSearchingNdg}
          onChange={handleSelectTextSearchNdg}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <TextField
    margin="normal"
    placeholder=""
    required
    fullWidth
    value={ndg}
    variant="standard"
    helperText=""
    id="search"
    name="search"
    autoComplete="search"
    onChange={handleChangeNDG}
    autoFocus
    sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
  />
  <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearNdg}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell6 === cellNames[1] && (
<div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
<Select
          name='cfSearching'
          value={textSearchingCf}
          onChange={handleSelectTextSearchCf}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={cf}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeCF}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}     

   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearCodiceFiscale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell6 === cellNames[2] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
    <Select
              name='ragioneSocialeSearching'
              value={textSearchingRagSociale}
              onChange={handleSelectTextSearchRagSociale}
              sx={{ width: '190px', height: '30px' }}

            >
             {textTypeSearch.map((opzione, index) => (
              <MenuItem key={index} value={opzione}>
                {opzione}
              </MenuItem>
            ))}
            </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={ragioneSociale}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeRagioneSociale}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearRagioneSociale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell6 === cellNames[8] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
       <Select
          name='giorniSearching'
          value={textSearchingGiorni}
          onChange={handleSelectTextSearchGiorni}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={giorni}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeGiorni}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', 
      padding: 0, 
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', 
        borderRadius: '4px', 
      },
      marginTop: '5px', 
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGiorni}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>

   
   
   
</div>

  )}

  
  
</div>
)}
{count >= 7 &&(
<div style={{ display: 'flex', flexDirection: 'row', alignItems:'center',marginTop:'10px' }}>
  
  <Select
    name='optSelect'
    value={cell7}
    onChange={handleSelectChangeColumn7}
    sx={{ width: '190px', height: '30px' }}
  >
    {cellNames.filter(opzione => opzione !== cell1 && opzione !== cell2 && opzione !== cell3 && opzione !== cell4 && opzione !== cell5 && opzione !== cell6 )
    .map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
  </Select>

 
  {cell7 === cellNames[6] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='statusSearching'
          value={selectSearchingStato}
          onChange={handleSelectSelectSearchStato}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='statoPraticaValue'
      value={stato}
      onChange={handleSelectChangeStato}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
      {statiList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearStatoPratica}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )
  }
  {cell7 === cellNames[4] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
      <Select
        name='dateSearching'
        value={dateSearching}
        onChange={handleDateTextSearch}
        sx={{ width: '190px', height: '30px' }}
      >
        {dateTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
      </Select>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>
  
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
      <DatePicker
      value={dataPraticaDa}
      onChange={handleDateChangePraticaDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataPraticaDa && (
                  <IconButton onClick={handleClearDataPraticaDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
      disabled={!isDataPraticaEnabled}
    />
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
  
        {dateSearching === "Periodo" && (
          <DatePicker
          value={dataPraticaA}
          onChange={handleDateChangePraticaA}
          renderInput={(props) => (
            <TextField
              {...props}
              label="A"
              InputProps={{
                ...props.InputProps,
                endAdornment: (
                  <InputAdornment position="end">
                    
                    {dataPraticaA && (
                      <IconButton onClick={handleClearDataPraticaA} sx={{ marginRight: '-25px' }}> 
                        <CancelIcon />
                      </IconButton>
                    )}
                    {props.InputProps.endAdornment}
                  </InputAdornment>
                ),
              }}
              sx={{
                width: '190px',
                paddingRight: 0,
                paddingBottom: 3,
                '& .MuiSvgIcon-root': {
                  marginRight: '5px',
                },
                '& .MuiInputBase-root': {
                  border: '1px solid #ced4da',
                  borderRadius: '4px',
                },
              }}
            />
          )}
          format="DD/MM/YYYY"
          sx={{ flexGrow:1 }}
          disabled={!isDataPraticaEnabled}
        />
        )}
        </div>
      </LocalizationProvider>
      </div>
  
    </div>

)}
{cell7 === cellNames[5] && (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
    <Select
      name='dateSearching'
      value={dateSearchingStatus}
      onChange={handleDateStatusTextSearch}
      sx={{ width: '190px', height: '30px' }}
    >
      {dateTypeSearch.map((opzione, index) => (
        <MenuItem key={index} value={opzione}>
          {opzione}
        </MenuItem>
      ))}
    </Select>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>

    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
    <DatePicker
      value={dataStatusDa}
      onChange={handleDateChangeStatusDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataStatusDa && (
                  <IconButton onClick={handleClearDataStatusDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
    />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>

      {dateSearchingStatus === "Periodo" && (
        <DatePicker
        value={dataStatusA}
        onChange={handleDateChangeStatusA}
        renderInput={(props) => (
          <TextField
            {...props}
            label="A"
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  
                  {dataStatusA && (
                    <IconButton onClick={handleClearDataStatusA} sx={{ marginRight: '-25px' }}> 
                      <CancelIcon />
                    </IconButton>
                  )}
                  {props.InputProps.endAdornment}
                </InputAdornment>
              ),
            }}
            sx={{
              width: '190px',
              paddingRight: 0,
              paddingBottom: 3,
              '& .MuiSvgIcon-root': {
                marginRight: '5px',
              },
              '& .MuiInputBase-root': {
                border: '1px solid #ced4da',
                borderRadius: '4px',
              },
            }}
          />
        )}
        format="DD/MM/YYYY"
        sx={{ flexGrow: 1 }}
      />
      )}
      </div>
    </LocalizationProvider>
    </div>

  </div>
)}
  {cell7 === cellNames[7] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
           name='esitoSearching'
           value={selectSearchingEsito}
           onChange={handleSelectSelectSearchEsito}
           sx={{ width: '190px', height: '30px' }}

         >
          {selectTypeSearch.map((opzione, index) => (
           <MenuItem key={index} value={opzione}>
             {opzione}
           </MenuItem>
         ))}
         </Select>
    <Select
      name='esitoSinteticoValue'
      value={esito}
      onChange={handleSelectChangeEsito}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
     {esitoSintetico.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoSintetico}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell7 === cellNames[9] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='esitoMonitoraggioSearching'
          value={selectSearchingEsitoMonitoraggio}
          onChange={handleSelectSelectSearchEsitoMonitoraggio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='esitoInserimentoValue'
      value={esitoM}
      onChange={handleSelectChangeEsitoMonitoraggio}
      sx={{ width: '190px', height: '30px' }}

    >
     {esitoMonitoraggioFondi.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoMonitoraggio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell7 === cellNames[10] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='livelloRischioSearching'
          value={selectSearchingLivelloRischio}
          onChange={handleSelectSelectSearchLivelloRischio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='livelloRischioInserimentoValue'
      value={livelloRischio}
      onChange={handleSelectChangeLivelloRischio}
      sx={{ width: '190px', height: '30px' }}

    >
     {livelloDiRischio.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearLivelloRischio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell7 === cellNames[11] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='inSofferenzaSearching'
          value={selectInSofferenza}
          onChange={handleChangeInSofferenza}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='inSofforenzaValue'
      value={inSofferenza}
      onChange={handleSelectChangeInSofferenza}
      sx={{ width: '190px', height: '30px' }}

    >
     {inSofferenzaList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={() => {
        console.log('IconButton clicked');
        handleClearInSofferenza();
      }}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell7 === cellNames[3] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
          name='gestoreSearching'
          value={selectGestore}
          onChange={handleSelectTextSearchGestore}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
        <Select
      name='gestoreValue'
      value={gestore}
      onChange={handleSelectGestore}
      sx={{ width: '190px', height: '30px' }}

    >
     {gestoreList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGestore}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}



  {cell7 === cellNames[0] && (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='ndgSearching'
          value={textSearchingNdg}
          onChange={handleSelectTextSearchNdg}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <TextField
    margin="normal"
    placeholder=""
    required
    fullWidth
    value={ndg}
    variant="standard"
    helperText=""
    id="search"
    name="search"
    autoComplete="search"
    onChange={handleChangeNDG}
    autoFocus
    sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
  /><IconButton
  id="basic-button"
  aria-controls={open ? 'basic-menu' : undefined}
  aria-haspopup="true"
  aria-expanded={open ? 'true' : undefined}
  onClick={handleClearNdg}
  title="Clear"
>
  <CancelIcon></CancelIcon>
</IconButton></div>
  )}
  {cell7 === cellNames[1] && (
               <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='cfSearching'
          value={textSearchingCf}
          onChange={handleSelectTextSearchCf}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={cf}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeCF}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}     

   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearCodiceFiscale}
      title="Clear"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell7 === cellNames[2] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
    <Select
              name='ragioneSocialeSearching'
              value={textSearchingRagSociale}
              onChange={handleSelectTextSearchRagSociale}
              sx={{ width: '190px', height: '30px' }}

            >
             {textTypeSearch.map((opzione, index) => (
              <MenuItem key={index} value={opzione}>
                {opzione}
              </MenuItem>
            ))}
            </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={ragioneSociale}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeRagioneSociale}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearRagioneSociale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
   {cell7 === cellNames[8] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
       <Select
          name='giorniSearching'
          value={textSearchingGiorni}
          onChange={handleSelectTextSearchGiorni}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={giorni}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeGiorni}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', 
      padding: 0, 
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', 
        borderRadius: '4px', 
      },
      marginTop: '5px', 
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGiorni}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>

   
   
   
</div>

  )}

  
  
</div>
)}
{count >= 8 &&(
<div style={{ display: 'flex', flexDirection: 'row', alignItems:'center',marginTop:'10px' }}>
  
  <Select
    name='optSelect'
    value={cell8}
    onChange={handleSelectChangeColumn8}
    sx={{ width: '190px', height: '30px' }}
  >
    {cellNames.filter(opzione => opzione !== cell1 && opzione !== cell2 && opzione !== cell3 && opzione !== cell4 && opzione !== cell5 && opzione !== cell6 && opzione !== cell7 )
    .map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
  </Select>

 
  {cell8 === cellNames[6] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='statusSearching'
          value={selectSearchingStato}
          onChange={handleSelectSelectSearchStato}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='statoPraticaValue'
      value={stato}
      onChange={handleSelectChangeStato}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
      {statiList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearStatoPratica}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )
  }
  {cell8 === cellNames[4] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
      <Select
        name='dateSearching'
        value={dateSearching}
        onChange={handleDateTextSearch}
        sx={{ width: '190px', height: '30px' }}
      >
        {dateTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
      </Select>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>
  
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
      <DatePicker
      value={dataPraticaDa}
      onChange={handleDateChangePraticaDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataPraticaDa && (
                  <IconButton onClick={handleClearDataPraticaDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
      disabled={!isDataPraticaEnabled}
    />
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
  
        {dateSearching === "Periodo" && (
          <DatePicker
          value={dataPraticaA}
          onChange={handleDateChangePraticaA}
          renderInput={(props) => (
            <TextField
              {...props}
              label="A"
              InputProps={{
                ...props.InputProps,
                endAdornment: (
                  <InputAdornment position="end">
                    
                    {dataPraticaA && (
                      <IconButton onClick={handleClearDataPraticaA} sx={{ marginRight: '-25px' }}> 
                        <CancelIcon />
                      </IconButton>
                    )}
                    {props.InputProps.endAdornment}
                  </InputAdornment>
                ),
              }}
              sx={{
                width: '190px',
                paddingRight: 0,
                paddingBottom: 3,
                '& .MuiSvgIcon-root': {
                  marginRight: '5px',
                },
                '& .MuiInputBase-root': {
                  border: '1px solid #ced4da',
                  borderRadius: '4px',
                },
              }}
            />
          )}
          format="DD/MM/YYYY"
          sx={{ flexGrow:1}}
          disabled={!isDataPraticaEnabled}
        />
        )}
        </div>
      </LocalizationProvider>
      </div>
  
    </div>

)}
{cell8 === cellNames[5] && (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
    <Select
      name='statusSearching'
      value={dateSearchingStatus}
      onChange={handleDateStatusTextSearch}
      sx={{ width: '190px', height: '30px' }}
    >
      {dateTypeSearch.map((opzione, index) => (
        <MenuItem key={index} value={opzione}>
          {opzione}
        </MenuItem>
      ))}
    </Select>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>

    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
    <DatePicker
      value={dataStatusDa}
      onChange={handleDateChangeStatusDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataStatusDa && (
                  <IconButton onClick={handleClearDataStatusDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
    />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>

      {dateSearchingStatus === "Periodo" && (
        <DatePicker
        value={dataStatusA}
        onChange={handleDateChangeStatusA}
        renderInput={(props) => (
          <TextField
            {...props}
            label="A"
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  
                  {dataStatusA && (
                    <IconButton onClick={handleClearDataStatusA} sx={{ marginRight: '-25px' }}> 
                      <CancelIcon />
                    </IconButton>
                  )}
                  {props.InputProps.endAdornment}
                </InputAdornment>
              ),
            }}
            sx={{
              width: '190px',
              paddingRight: 0,
              paddingBottom: 3,
              '& .MuiSvgIcon-root': {
                marginRight: '5px',
              },
              '& .MuiInputBase-root': {
                border: '1px solid #ced4da',
                borderRadius: '4px',
              },
            }}
          />
        )}
        format="DD/MM/YYYY"
        sx={{ flexGrow: 1 }}
      />
      )}
      </div>
    </LocalizationProvider>
    </div>

  </div>
)}
  {cell8 === cellNames[7] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
           name='esitoSearching'
           value={selectSearchingEsito}
           onChange={handleSelectSelectSearchEsito}
           sx={{ width: '190px', height: '30px' }}

         >
          {selectTypeSearch.map((opzione, index) => (
           <MenuItem key={index} value={opzione}>
             {opzione}
           </MenuItem>
         ))}
         </Select>
    <Select
      name='esitoSinteticoValue'
      value={esito}
      onChange={handleSelectChangeEsito}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
     {esitoSintetico.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoSintetico}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>
    
    </div>
  )}
  {cell8 === cellNames[9] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='esitoMonitoraggioSearching'
          value={selectSearchingEsitoMonitoraggio}
          onChange={handleSelectSelectSearchEsitoMonitoraggio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='esitoInserimentoValue'
      value={esitoM}
      onChange={handleSelectChangeEsitoMonitoraggio}
      sx={{ width: '190px', height: '30px' }}

    >
     {esitoMonitoraggioFondi.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoMonitoraggio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell8 === cellNames[10] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='livelloRischioSearching'
          value={selectSearchingLivelloRischio}
          onChange={handleSelectSelectSearchLivelloRischio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='livelloRischioInserimentoValue'
      value={livelloRischio}
      onChange={handleSelectChangeLivelloRischio}
      sx={{ width: '190px', height: '30px' }}

    >
     {livelloDiRischio.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearLivelloRischio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell8 === cellNames[11] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='inSofferenzaSearching'
          value={selectInSofferenza}
          onChange={handleChangeInSofferenza}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='inSofforenzaValue'
      value={inSofferenza}
      onChange={handleSelectChangeInSofferenza}
      sx={{ width: '190px', height: '30px' }}

    >
     {inSofferenzaList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={() => {
        console.log('IconButton clicked');
        handleClearInSofferenza();
      }}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell8 === cellNames[3] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
          name='gestoreSearching'
          value={selectGestore}
          onChange={handleSelectTextSearchGestore}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
        <Select
      name='gestoreValue'
      value={gestore}
      onChange={handleSelectGestore}
      sx={{ width: '190px', height: '30px' }}

    >
     {gestoreList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGestore}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}

  {cell8 === cellNames[0] && (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='ndgSearching'
          value={textSearchingNdg}
          onChange={handleSelectTextSearchNdg}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <TextField
    margin="normal"
    placeholder=""
    required
    fullWidth
    value={ndg}
    variant="standard"
    helperText=""
    id="search"
    name="search"
    autoComplete="search"
    onChange={handleChangeNDG}
    autoFocus
    sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
  /><IconButton
  id="basic-button"
  aria-controls={open ? 'basic-menu' : undefined}
  aria-haspopup="true"
  aria-expanded={open ? 'true' : undefined}
  onClick={handleClearNdg}
  title="Clear"
>
  <CancelIcon></CancelIcon>
</IconButton></div>
  )}
  {cell8 === cellNames[1] && (
               <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='cfSearching'
          value={textSearchingCf}
          onChange={handleSelectTextSearchCf}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={cf}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeCF}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}     

   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearCodiceFiscale}
      title="Clear"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell8 === cellNames[2] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
    <Select
              name='ragioneSocialeSearching'
              value={textSearchingRagSociale}
              onChange={handleSelectTextSearchRagSociale}
              sx={{ width: '190px', height: '30px' }}

            >
             {textTypeSearch.map((opzione, index) => (
              <MenuItem key={index} value={opzione}>
                {opzione}
              </MenuItem>
            ))}
            </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={ragioneSociale}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeRagioneSociale}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearRagioneSociale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
{cell8 === cellNames[8] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
       <Select
          name='giorniSearching'
          value={textSearchingGiorni}
          onChange={handleSelectTextSearchGiorni}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={giorni}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeGiorni}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', 
      padding: 0, 
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', 
        borderRadius: '4px', 
      },
      marginTop: '5px', 
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGiorni}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>

   
   
   
</div>

  )}
  
  
</div>
)}

{count >= 9 &&(
<div style={{ display: 'flex', flexDirection: 'row', alignItems:'center',marginTop:'10px' }}>
  
  <Select
    name='optSelect'
    value={cell9}
    onChange={handleSelectChangeColumn9}
    sx={{ width: '190px', height: '30px' }}
  >
    {cellNames.filter(opzione => opzione !== cell1 && opzione !== cell2 && opzione !== cell3 && opzione !== cell4 && opzione !== cell5 && opzione !== cell6 && opzione !== cell7 && opzione !== cell8 )
    .map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
  </Select>

 
  {cell9 === cellNames[6] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='statusSearching'
          value={selectSearchingStato}
          onChange={handleSelectSelectSearchStato}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='statoPraticaValue'
      value={stato}
      onChange={handleSelectChangeStato}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
      {statiList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearStatoPratica}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )
  }
  {cell9 === cellNames[4] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
      <Select
        name='dateSearching'
        value={dateSearching}
        onChange={handleDateTextSearch}
        sx={{ width: '190px', height: '30px' }}
      >
        {dateTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
      </Select>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>
  
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
      <DatePicker
      value={dataPraticaDa}
      onChange={handleDateChangePraticaDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataPraticaDa && (
                  <IconButton onClick={handleClearDataPraticaDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
      disabled={!isDataPraticaEnabled}
    />
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
  
        {dateSearching === "Periodo" && (
          <DatePicker
          value={dataPraticaA}
          onChange={handleDateChangePraticaA}
          renderInput={(props) => (
            <TextField
              {...props}
              label="A"
              InputProps={{
                ...props.InputProps,
                endAdornment: (
                  <InputAdornment position="end">
                    
                    {dataPraticaA && (
                      <IconButton onClick={handleClearDataPraticaA} sx={{ marginRight: '-25px' }}> 
                        <CancelIcon />
                      </IconButton>
                    )}
                    {props.InputProps.endAdornment}
                  </InputAdornment>
                ),
              }}
              sx={{
                width: '190px',
                paddingRight: 0,
                paddingBottom: 3,
                '& .MuiSvgIcon-root': {
                  marginRight: '5px',
                },
                '& .MuiInputBase-root': {
                  border: '1px solid #ced4da',
                  borderRadius: '4px',
                },
              }}
            />
          )}
          format="DD/MM/YYYY"
          sx={{ flexGrow:1}}
          disabled={!isDataPraticaEnabled}
        />
        )}
        </div>
      </LocalizationProvider>
      </div>
  
    </div>

)}
{cell9 === cellNames[5] && (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
    <Select
      name='statusSearching'
      value={dateSearchingStatus}
      onChange={handleDateStatusTextSearch}
      sx={{ width: '190px', height: '30px' }}
    >
      {dateTypeSearch.map((opzione, index) => (
        <MenuItem key={index} value={opzione}>
          {opzione}
        </MenuItem>
      ))}
    </Select>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>

    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
    <DatePicker
      value={dataStatusDa}
      onChange={handleDateChangeStatusDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataStatusDa && (
                  <IconButton onClick={handleClearDataStatusDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
    />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>

      {dateSearchingStatus === "Periodo" && (
        <DatePicker
        value={dataStatusA}
        onChange={handleDateChangeStatusA}
        renderInput={(props) => (
          <TextField
            {...props}
            label="A"
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  
                  {dataStatusA && (
                    <IconButton onClick={handleClearDataStatusA} sx={{ marginRight: '-25px' }}> 
                      <CancelIcon />
                    </IconButton>
                  )}
                  {props.InputProps.endAdornment}
                </InputAdornment>
              ),
            }}
            sx={{
              width: '190px',
              paddingRight: 0,
              paddingBottom: 3,
              '& .MuiSvgIcon-root': {
                marginRight: '5px',
              },
              '& .MuiInputBase-root': {
                border: '1px solid #ced4da',
                borderRadius: '4px',
              },
            }}
          />
        )}
        format="DD/MM/YYYY"
        sx={{ flexGrow: 1 }}
      />
      )}
      </div>
    </LocalizationProvider>
    </div>

  </div>
)}
  {cell9 === cellNames[7] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
           name='esitoSearching'
           value={selectSearchingEsito}
           onChange={handleSelectSelectSearchEsito}
           sx={{ width: '190px', height: '30px' }}

         >
          {selectTypeSearch.map((opzione, index) => (
           <MenuItem key={index} value={opzione}>
             {opzione}
           </MenuItem>
         ))}
         </Select>
    <Select
      name='esitoSinteticoValue'
      value={esito}
      onChange={handleSelectChangeEsito}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
     {esitoSintetico.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoSintetico}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>
    
    </div>
  )}
  {cell9 === cellNames[9] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='esitoMonitoraggioSearching'
          value={selectSearchingEsitoMonitoraggio}
          onChange={handleSelectSelectSearchEsitoMonitoraggio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='esitoInserimentoValue'
      value={esitoM}
      onChange={handleSelectChangeEsitoMonitoraggio}
      sx={{ width: '190px', height: '30px' }}

    >
     {esitoMonitoraggioFondi.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoMonitoraggio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell9 === cellNames[10] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='livelloRischioSearching'
          value={selectSearchingLivelloRischio}
          onChange={handleSelectSelectSearchLivelloRischio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='livelloRischioInserimentoValue'
      value={livelloRischio}
      onChange={handleSelectChangeLivelloRischio}
      sx={{ width: '190px', height: '30px' }}

    >
     {livelloDiRischio.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearLivelloRischio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell9 === cellNames[11] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='inSofferenzaSearching'
          value={selectInSofferenza}
          onChange={handleChangeInSofferenza}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='inSofforenzaValue'
      value={inSofferenza}
      onChange={handleSelectChangeInSofferenza}
      sx={{ width: '190px', height: '30px' }}

    >
     {inSofferenzaList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={() => {
        console.log('IconButton clicked');
        handleClearInSofferenza();
      }}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell9 === cellNames[3] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
          name='gestoreSearching'
          value={selectGestore}
          onChange={handleSelectTextSearchGestore}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
        <Select
      name='gestoreValue'
      value={gestore}
      onChange={handleSelectGestore}
      sx={{ width: '190px', height: '30px' }}

    >
     {gestoreList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGestore}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}

  {cell9 === cellNames[0] && (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='ndgSearching'
          value={textSearchingNdg}
          onChange={handleSelectTextSearchNdg}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <TextField
    margin="normal"
    placeholder=""
    required
    fullWidth
    value={ndg}
    variant="standard"
    helperText=""
    id="search"
    name="search"
    autoComplete="search"
    onChange={handleChangeNDG}
    autoFocus
    sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
  /><IconButton
  id="basic-button"
  aria-controls={open ? 'basic-menu' : undefined}
  aria-haspopup="true"
  aria-expanded={open ? 'true' : undefined}
  onClick={handleClearNdg}
  title="Clear"
>
  <CancelIcon></CancelIcon>
</IconButton></div>
  )}
  {cell9 === cellNames[1] && (
               <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='cfSearching'
          value={textSearchingCf}
          onChange={handleSelectTextSearchCf}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={cf}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeCF}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}     

   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearCodiceFiscale}
      title="Clear"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell9 === cellNames[2] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
    <Select
              name='ragioneSocialeSearching'
              value={textSearchingRagSociale}
              onChange={handleSelectTextSearchRagSociale}
              sx={{ width: '190px', height: '30px' }}

            >
             {textTypeSearch.map((opzione, index) => (
              <MenuItem key={index} value={opzione}>
                {opzione}
              </MenuItem>
            ))}
            </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={ragioneSociale}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeRagioneSociale}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearRagioneSociale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
{cell9 === cellNames[8] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
       <Select
          name='giorniSearching'
          value={textSearchingGiorni}
          onChange={handleSelectTextSearchGiorni}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={giorni}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeGiorni}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', 
      padding: 0, 
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', 
        borderRadius: '4px', 
      },
      marginTop: '5px', 
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGiorni}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>

   
   
   
</div>

  )}
  
  
</div>
)}
{count >= 10 &&(
<div style={{ display: 'flex', flexDirection: 'row', alignItems:'center',marginTop:'10px' }}>
  
  <Select
    name='optSelect'
    value={cell10}
    onChange={handleSelectChangeColumn10}
    sx={{ width: '190px', height: '30px' }}
  >
    {cellNames.filter(opzione => opzione !== cell1 && opzione !== cell2 && opzione !== cell3 && opzione !== cell4 && opzione !== cell5 && opzione !== cell6 && opzione !== cell7 && opzione !== cell8 && opzione !== cell9 )
    .map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
  </Select>

 
  {cell10 === cellNames[6] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='statusSearching'
          value={selectSearchingStato}
          onChange={handleSelectSelectSearchStato}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='statoPraticaValue'
      value={stato}
      onChange={handleSelectChangeStato}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
      {statiList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearStatoPratica}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )
  }
  {cell10 === cellNames[4] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
      <Select
        name='dateSearching'
        value={dateSearching}
        onChange={handleDateTextSearch}
        sx={{ width: '190px', height: '30px' }}
      >
        {dateTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
      </Select>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>
  
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
      <DatePicker
      value={dataPraticaDa}
      onChange={handleDateChangePraticaDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataPraticaDa && (
                  <IconButton onClick={handleClearDataPraticaDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
      disabled={!isDataPraticaEnabled}
    />
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
  
        {dateSearching === "Periodo" && (
          <DatePicker
          value={dataPraticaA}
          onChange={handleDateChangePraticaA}
          renderInput={(props) => (
            <TextField
              {...props}
              label="A"
              InputProps={{
                ...props.InputProps,
                endAdornment: (
                  <InputAdornment position="end">
                    
                    {dataPraticaA && (
                      <IconButton onClick={handleClearDataPraticaA} sx={{ marginRight: '-25px' }}> 
                        <CancelIcon />
                      </IconButton>
                    )}
                    {props.InputProps.endAdornment}
                  </InputAdornment>
                ),
              }}
              sx={{
                width: '190px',
                paddingRight: 0,
                paddingBottom: 3,
                '& .MuiSvgIcon-root': {
                  marginRight: '5px',
                },
                '& .MuiInputBase-root': {
                  border: '1px solid #ced4da',
                  borderRadius: '4px',
                },
              }}
            />
          )}
          format="DD/MM/YYYY"
          sx={{ flexGrow:1}}
          disabled={!isDataPraticaEnabled}
        />
        )}
        </div>
      </LocalizationProvider>
      </div>
  
    </div>

)}
{cell10 === cellNames[5] && (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
    <Select
      name='statusSearching'
      value={dateSearchingStatus}
      onChange={handleDateStatusTextSearch}
      sx={{ width: '190px', height: '30px' }}
    >
      {dateTypeSearch.map((opzione, index) => (
        <MenuItem key={index} value={opzione}>
          {opzione}
        </MenuItem>
      ))}
    </Select>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>

    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
    <DatePicker
      value={dataStatusDa}
      onChange={handleDateChangeStatusDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataStatusDa && (
                  <IconButton onClick={handleClearDataStatusDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
    />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>

      {dateSearchingStatus === "Periodo" && (
        <DatePicker
        value={dataStatusA}
        onChange={handleDateChangeStatusA}
        renderInput={(props) => (
          <TextField
            {...props}
            label="A"
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  
                  {dataStatusA && (
                    <IconButton onClick={handleClearDataStatusA} sx={{ marginRight: '-25px' }}> 
                      <CancelIcon />
                    </IconButton>
                  )}
                  {props.InputProps.endAdornment}
                </InputAdornment>
              ),
            }}
            sx={{
              width: '190px',
              paddingRight: 0,
              paddingBottom: 3,
              '& .MuiSvgIcon-root': {
                marginRight: '5px',
              },
              '& .MuiInputBase-root': {
                border: '1px solid #ced4da',
                borderRadius: '4px',
              },
            }}
          />
        )}
        format="DD/MM/YYYY"
        sx={{ flexGrow: 1 }}
      />
      )}
      </div>
    </LocalizationProvider>
    </div>

  </div>
)}
  {cell10 === cellNames[7] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
           name='esitoSearching'
           value={selectSearchingEsito}
           onChange={handleSelectSelectSearchEsito}
           sx={{ width: '190px', height: '30px' }}

         >
          {selectTypeSearch.map((opzione, index) => (
           <MenuItem key={index} value={opzione}>
             {opzione}
           </MenuItem>
         ))}
         </Select>
    <Select
      name='esitoSinteticoValue'
      value={esito}
      onChange={handleSelectChangeEsito}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
     {esitoSintetico.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoSintetico}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>
    
    </div>
  )}
  {cell10 === cellNames[9] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='esitoMonitoraggioSearching'
          value={selectSearchingEsitoMonitoraggio}
          onChange={handleSelectSelectSearchEsitoMonitoraggio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='esitoInserimentoValue'
      value={esitoM}
      onChange={handleSelectChangeEsitoMonitoraggio}
      sx={{ width: '190px', height: '30px' }}

    >
     {esitoMonitoraggioFondi.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoMonitoraggio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell10 === cellNames[10] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='livelloRischioSearching'
          value={selectSearchingLivelloRischio}
          onChange={handleSelectSelectSearchLivelloRischio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='livelloRischioInserimentoValue'
      value={livelloRischio}
      onChange={handleSelectChangeLivelloRischio}
      sx={{ width: '190px', height: '30px' }}

    >
     {livelloDiRischio.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearLivelloRischio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell10 === cellNames[11] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='inSofferenzaSearching'
          value={selectInSofferenza}
          onChange={handleChangeInSofferenza}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='inSofforenzaValue'
      value={inSofferenza}
      onChange={handleSelectChangeInSofferenza}
      sx={{ width: '190px', height: '30px' }}

    >
     {inSofferenzaList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={() => {
        console.log('IconButton clicked');
        handleClearInSofferenza();
      }}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell10 === cellNames[3] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
          name='gestoreSearching'
          value={selectGestore}
          onChange={handleSelectTextSearchGestore}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
        <Select
      name='gestoreValue'
      value={gestore}
      onChange={handleSelectGestore}
      sx={{ width: '190px', height: '30px' }}

    >
     {gestoreList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGestore}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}



  {cell10 === cellNames[0] && (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='ndgSearching'
          value={textSearchingNdg}
          onChange={handleSelectTextSearchNdg}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <TextField
    margin="normal"
    placeholder=""
    required
    fullWidth
    value={ndg}
    variant="standard"
    helperText=""
    id="search"
    name="search"
    autoComplete="search"
    onChange={handleChangeNDG}
    autoFocus
    sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
  /><IconButton
  id="basic-button"
  aria-controls={open ? 'basic-menu' : undefined}
  aria-haspopup="true"
  aria-expanded={open ? 'true' : undefined}
  onClick={handleClearNdg}
  title="Clear"
>
  <CancelIcon></CancelIcon>
</IconButton></div>
  )}
  {cell10 === cellNames[1] && (
               <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='cfSearching'
          value={textSearchingCf}
          onChange={handleSelectTextSearchCf}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={cf}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeCF}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}     

   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearCodiceFiscale}
      title="Clear"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell10 === cellNames[2] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
    <Select
              name='ragioneSocialeSearching'
              value={textSearchingRagSociale}
              onChange={handleSelectTextSearchRagSociale}
              sx={{ width: '190px', height: '30px' }}

            >
             {textTypeSearch.map((opzione, index) => (
              <MenuItem key={index} value={opzione}>
                {opzione}
              </MenuItem>
            ))}
            </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={ragioneSociale}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeRagioneSociale}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearRagioneSociale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
{cell10 === cellNames[8] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
       <Select
          name='giorniSearching'
          value={textSearchingGiorni}
          onChange={handleSelectTextSearchGiorni}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={giorni}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeGiorni}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', 
      padding: 0, 
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', 
        borderRadius: '4px', 
      },
      marginTop: '5px', 
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGiorni}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>

   
   
   
</div>

  )}
  
  
</div>
)}

{count >= 11 &&(
<div style={{ display: 'flex', flexDirection: 'row', alignItems:'center',marginTop:'10px' }}>
  
  <Select
    name='optSelect'
    value={cell11}
    onChange={handleSelectChangeColumn11}
    sx={{ width: '190px', height: '30px' }}
  >
    {cellNames.filter(opzione => opzione !== cell1 && opzione !== cell2 && opzione !== cell3 && opzione !== cell4 && opzione !== cell5 && opzione !== cell6 && opzione !== cell7 && opzione !== cell8 && opzione !== cell9 && opzione !== cell10 )
    .map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
  </Select>

 
  {cell11 === cellNames[6] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='statusSearching'
          value={selectSearchingStato}
          onChange={handleSelectSelectSearchStato}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='statoPraticaValue'
      value={stato}
      onChange={handleSelectChangeStato}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
      {statiList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearStatoPratica}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )
  }
  {cell11 === cellNames[4] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
      <Select
        name='dateSearching'
        value={dateSearching}
        onChange={handleDateTextSearch}
        sx={{ width: '190px', height: '30px' }}
      >
        {dateTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
      </Select>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>
  
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
      <DatePicker
      value={dataPraticaDa}
      onChange={handleDateChangePraticaDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataPraticaDa && (
                  <IconButton onClick={handleClearDataPraticaDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
      disabled={!isDataPraticaEnabled}
    />
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
  
        {dateSearching === "Periodo" && (
          <DatePicker
          value={dataPraticaA}
          onChange={handleDateChangePraticaA}
          renderInput={(props) => (
            <TextField
              {...props}
              label="A"
              InputProps={{
                ...props.InputProps,
                endAdornment: (
                  <InputAdornment position="end">
                    
                    {dataPraticaA && (
                      <IconButton onClick={handleClearDataPraticaA} sx={{ marginRight: '-25px' }}> 
                        <CancelIcon />
                      </IconButton>
                    )}
                    {props.InputProps.endAdornment}
                  </InputAdornment>
                ),
              }}
              sx={{
                width: '190px',
                paddingRight: 0,
                paddingBottom: 3,
                '& .MuiSvgIcon-root': {
                  marginRight: '5px',
                },
                '& .MuiInputBase-root': {
                  border: '1px solid #ced4da',
                  borderRadius: '4px',
                },
              }}
            />
          )}
          format="DD/MM/YYYY"
          sx={{ flexGrow:1}}
          disabled={!isDataPraticaEnabled}
        />
        )}
        </div>
      </LocalizationProvider>
      </div>
  
    </div>

)}
{cell11 === cellNames[5] && (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
    <Select
      name='statusSearching'
      value={dateSearchingStatus}
      onChange={handleDateStatusTextSearch}
      sx={{ width: '190px', height: '30px' }}
    >
      {dateTypeSearch.map((opzione, index) => (
        <MenuItem key={index} value={opzione}>
          {opzione}
        </MenuItem>
      ))}
    </Select>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>

    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
    <DatePicker
      value={dataStatusDa}
      onChange={handleDateChangeStatusDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataStatusDa && (
                  <IconButton onClick={handleClearDataStatusDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
    />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>

      {dateSearchingStatus === "Periodo" && (
        <DatePicker
        value={dataStatusA}
        onChange={handleDateChangeStatusA}
        renderInput={(props) => (
          <TextField
            {...props}
            label="A"
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  
                  {dataStatusA && (
                    <IconButton onClick={handleClearDataStatusA} sx={{ marginRight: '-25px' }}> 
                      <CancelIcon />
                    </IconButton>
                  )}
                  {props.InputProps.endAdornment}
                </InputAdornment>
              ),
            }}
            sx={{
              width: '190px',
              paddingRight: 0,
              paddingBottom: 3,
              '& .MuiSvgIcon-root': {
                marginRight: '5px',
              },
              '& .MuiInputBase-root': {
                border: '1px solid #ced4da',
                borderRadius: '4px',
              },
            }}
          />
        )}
        format="DD/MM/YYYY"
        sx={{ flexGrow: 1 }}
      />
      )}
      </div>
    </LocalizationProvider>
    </div>

  </div>
)}
  {cell11 === cellNames[7] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
           name='esitoSearching'
           value={selectSearchingEsito}
           onChange={handleSelectSelectSearchEsito}
           sx={{ width: '190px', height: '30px' }}

         >
          {selectTypeSearch.map((opzione, index) => (
           <MenuItem key={index} value={opzione}>
             {opzione}
           </MenuItem>
         ))}
         </Select>
    <Select
      name='esitoSinteticoValue'
      value={esito}
      onChange={handleSelectChangeEsito}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
     {esitoSintetico.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoSintetico}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>
    
    </div>
  )}
  {cell11 === cellNames[9] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='esitoMonitoraggioSearching'
          value={selectSearchingEsitoMonitoraggio}
          onChange={handleSelectSelectSearchEsitoMonitoraggio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='esitoInserimentoValue'
      value={esitoM}
      onChange={handleSelectChangeEsitoMonitoraggio}
      sx={{ width: '190px', height: '30px' }}

    >
     {esitoMonitoraggioFondi.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoMonitoraggio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell11 === cellNames[10] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='livelloRischioSearching'
          value={selectSearchingLivelloRischio}
          onChange={handleSelectSelectSearchLivelloRischio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='livelloRischioInserimentoValue'
      value={livelloRischio}
      onChange={handleSelectChangeLivelloRischio}
      sx={{ width: '190px', height: '30px' }}

    >
     {livelloDiRischio.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearLivelloRischio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell11 === cellNames[3] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
          name='gestoreSearching'
          value={selectGestore}
          onChange={handleSelectTextSearchGestore}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
        <Select
      name='gestoreValue'
      value={gestore}
      onChange={handleSelectGestore}
      sx={{ width: '190px', height: '30px' }}

    >
     {gestoreList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGestore}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}



  {cell11 === cellNames[0] && (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='ndgSearching'
          value={textSearchingNdg}
          onChange={handleSelectTextSearchNdg}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <TextField
    margin="normal"
    placeholder=""
    required
    fullWidth
    value={ndg}
    variant="standard"
    helperText=""
    id="search"
    name="search"
    autoComplete="search"
    onChange={handleChangeNDG}
    autoFocus
    sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
  /><IconButton
  id="basic-button"
  aria-controls={open ? 'basic-menu' : undefined}
  aria-haspopup="true"
  aria-expanded={open ? 'true' : undefined}
  onClick={handleClearNdg}
  title="Clear"
>
  <CancelIcon></CancelIcon>
</IconButton></div>
  )}
  {cell11 === cellNames[1] && (
               <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='cfSearching'
          value={textSearchingCf}
          onChange={handleSelectTextSearchCf}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={cf}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeCF}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}     

   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearCodiceFiscale}
      title="Clear"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell11 === cellNames[2] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
    <Select
              name='ragioneSocialeSearching'
              value={textSearchingRagSociale}
              onChange={handleSelectTextSearchRagSociale}
              sx={{ width: '190px', height: '30px' }}

            >
             {textTypeSearch.map((opzione, index) => (
              <MenuItem key={index} value={opzione}>
                {opzione}
              </MenuItem>
            ))}
            </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={ragioneSociale}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeRagioneSociale}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearRagioneSociale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
{cell11 === cellNames[8] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
       <Select
          name='giorniSearching'
          value={textSearchingGiorni}
          onChange={handleSelectTextSearchGiorni}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={giorni}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeGiorni}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', 
      padding: 0, 
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', 
        borderRadius: '4px', 
      },
      marginTop: '5px', 
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGiorni}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>

   
   
   
</div>

  )}
  
  
</div>
)}
{count >= 12 &&(
<div style={{ display: 'flex', flexDirection: 'row', alignItems:'center',marginTop:'10px' }}>
  
  <Select
    name='optSelect'
    value={cell12}
    onChange={handleSelectChangeColumn12}
    sx={{ width: '190px', height: '30px' }}
  >
    {cellNames.filter(opzione => opzione !== cell1 && opzione !== cell2 && opzione !== cell3 && opzione !== cell4 && opzione !== cell5 && opzione !== cell6 && opzione !== cell7 && opzione !== cell8 && opzione !== cell9 && opzione !== cell10 && opzione !== cell11 )
    .map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
  </Select>

 
  {cell12 === cellNames[6] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='statusSearching'
          value={selectSearchingStato}
          onChange={handleSelectSelectSearchStato}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='statoPraticaValue'
      value={stato}
      onChange={handleSelectChangeStato}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
      {statiList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearStatoPratica}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )
  }
  {cell12 === cellNames[4] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
      <Select
        name='dateSearching'
        value={dateSearching}
        onChange={handleDateTextSearch}
        sx={{ width: '190px', height: '30px' }}
      >
        {dateTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
      </Select>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>
  
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
      <DatePicker
      value={dataPraticaDa}
      onChange={handleDateChangePraticaDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataPraticaDa && (
                  <IconButton onClick={handleClearDataPraticaDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
      disabled={!isDataPraticaEnabled}
    />
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
  
        {dateSearching === "Periodo" && (
          <DatePicker
          value={dataPraticaA}
          onChange={handleDateChangePraticaA}
          renderInput={(props) => (
            <TextField
              {...props}
              label="A"
              InputProps={{
                ...props.InputProps,
                endAdornment: (
                  <InputAdornment position="end">
                    
                    {dataPraticaA && (
                      <IconButton onClick={handleClearDataPraticaA} sx={{ marginRight: '-25px' }}> 
                        <CancelIcon />
                      </IconButton>
                    )}
                    {props.InputProps.endAdornment}
                  </InputAdornment>
                ),
              }}
              sx={{
                width: '190px',
                paddingRight: 0,
                paddingBottom: 3,
                '& .MuiSvgIcon-root': {
                  marginRight: '5px',
                },
                '& .MuiInputBase-root': {
                  border: '1px solid #ced4da',
                  borderRadius: '4px',
                },
              }}
            />
          )}
          format="DD/MM/YYYY"
          sx={{ flexGrow:1}}
          disabled={!isDataPraticaEnabled}
        />
        )}
        </div>
      </LocalizationProvider>
      </div>
  
    </div>

)}
{cell12 === cellNames[5] && (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>
    <Select
      name='statusSearching'
      value={dateSearchingStatus}
      onChange={handleDateStatusTextSearch}
      sx={{ width: '190px', height: '30px' }}
    >
      {dateTypeSearch.map((opzione, index) => (
        <MenuItem key={index} value={opzione}>
          {opzione}
        </MenuItem>
      ))}
    </Select>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>

    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
    <DatePicker
      value={dataStatusDa}
      onChange={handleDateChangeStatusDa}
      renderInput={(props) => (
        <TextField
          {...props}
          label="Da"
          InputProps={{
            ...props.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                
                {dataStatusDa && (
                  <IconButton onClick={handleClearDataStatusDa} sx={{ marginRight: '-25px' }}> 
                    <CancelIcon />
                  </IconButton>
                )}
                {props.InputProps.endAdornment}
              </InputAdornment>
            ),
          }}
          sx={{
            width: '190px',
            paddingRight: 0,
            paddingBottom: 3,
            '& .MuiSvgIcon-root': {
              marginRight: '5px',
            },
            '& .MuiInputBase-root': {
              border: '1px solid #ced4da',
              borderRadius: '4px',
            },
          }}
        />
      )}
      format="DD/MM/YYYY"
      sx={{ flexGrow: 1 }}
    />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start' }}>

      {dateSearchingStatus === "Periodo" && (
        <DatePicker
        value={dataStatusA}
        onChange={handleDateChangeStatusA}
        renderInput={(props) => (
          <TextField
            {...props}
            label="A"
            InputProps={{
              ...props.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  
                  {dataStatusA && (
                    <IconButton onClick={handleClearDataStatusA} sx={{ marginRight: '-25px' }}> 
                      <CancelIcon />
                    </IconButton>
                  )}
                  {props.InputProps.endAdornment}
                </InputAdornment>
              ),
            }}
            sx={{
              width: '190px',
              paddingRight: 0,
              paddingBottom: 3,
              '& .MuiSvgIcon-root': {
                marginRight: '5px',
              },
              '& .MuiInputBase-root': {
                border: '1px solid #ced4da',
                borderRadius: '4px',
              },
            }}
          />
        )}
        format="DD/MM/YYYY"
        sx={{ flexGrow: 1 }}
      />
      )}
      </div>
    </LocalizationProvider>
    </div>

  </div>
)}
  {cell12 === cellNames[7] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
           name='esitoSearching'
           value={selectSearchingEsito}
           onChange={handleSelectSelectSearchEsito}
           sx={{ width: '190px', height: '30px' }}

         >
          {selectTypeSearch.map((opzione, index) => (
           <MenuItem key={index} value={opzione}>
             {opzione}
           </MenuItem>
         ))}
         </Select>
    <Select
      name='esitoSinteticoValue'
      value={esito}
      onChange={handleSelectChangeEsito}
      sx={{ width: '190px', height: '30px' }}
      disabled={!isStatoEnabled}
    >
     {esitoSintetico.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoSintetico}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>
    
    </div>
  )}
  {cell12 === cellNames[9] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='esitoMonitoraggioSearching'
          value={selectSearchingEsitoMonitoraggio}
          onChange={handleSelectSelectSearchEsitoMonitoraggio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='esitoInserimentoValue'
      value={esitoM}
      onChange={handleSelectChangeEsitoMonitoraggio}
      sx={{ width: '190px', height: '30px' }}

    >
     {esitoMonitoraggioFondi.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearEsitoMonitoraggio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell12 === cellNames[10] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
    <Select
          name='livelloRischioSearching'
          value={selectSearchingLivelloRischio}
          onChange={handleSelectSelectSearchLivelloRischio}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <Select
      name='livelloRischioInserimentoValue'
      value={livelloRischio}
      onChange={handleSelectChangeLivelloRischio}
      sx={{ width: '190px', height: '30px' }}

    >
     {livelloDiRischio.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearLivelloRischio}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell12 === cellNames[3] && (
     <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
     <Select
          name='gestoreSearching'
          value={selectGestore}
          onChange={handleSelectTextSearchGestore}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
        <Select
      name='gestoreValue'
      value={gestore}
      onChange={handleSelectGestore}
      sx={{ width: '190px', height: '30px' }}

    >
     {gestoreList.map((opzione, index) => (
      <MenuItem key={index} value={opzione}>
        {opzione}
      </MenuItem>
    ))}
    </Select>
    <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGestore}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}



  {cell12 === cellNames[0] && (
              <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='ndgSearching'
          value={textSearchingNdg}
          onChange={handleSelectTextSearchNdg}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
    <TextField
    margin="normal"
    placeholder=""
    required
    fullWidth
    value={ndg}
    variant="standard"
    helperText=""
    id="search"
    name="search"
    autoComplete="search"
    onChange={handleChangeNDG}
    autoFocus
    sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}
  /><IconButton
  id="basic-button"
  aria-controls={open ? 'basic-menu' : undefined}
  aria-haspopup="true"
  aria-expanded={open ? 'true' : undefined}
  onClick={handleClearNdg}
  title="Clear"
>
  <CancelIcon></CancelIcon>
</IconButton></div>
  )}
  {cell12 === cellNames[1] && (
               <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start'}}>
<Select
          name='cfSearching'
          value={textSearchingCf}
          onChange={handleSelectTextSearchCf}
          sx={{ width: '190px', height: '30px' }}

        >
         {textTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={cf}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeCF}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', // Altezza simile al Select
      padding: 0, // Rimuovi il padding interno
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', // Imposta un bordo simile al Select
        borderRadius: '4px', // Puoi regolare il valore per adattarlo al tuo design
      },
      marginTop: '5px', // Sposta il TextField verso il basso
    }}     

   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearCodiceFiscale}
      title="Clear"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
  {cell12 === cellNames[2] && (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
    <Select
              name='ragioneSocialeSearching'
              value={textSearchingRagSociale}
              onChange={handleSelectTextSearchRagSociale}
              sx={{ width: '190px', height: '30px' }}

            >
             {textTypeSearch.map((opzione, index) => (
              <MenuItem key={index} value={opzione}>
                {opzione}
              </MenuItem>
            ))}
            </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={ragioneSociale}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeRagioneSociale}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', 

      padding: 0, 
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', 

        borderRadius: '4px', 

      },
      marginTop: '5px', 

    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearRagioneSociale}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton></div>
  )}
{cell12 === cellNames[8] && (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'start' }}>
       <Select
          name='giorniSearching'
          value={textSearchingGiorni}
          onChange={handleSelectTextSearchGiorni}
          sx={{ width: '190px', height: '30px' }}

        >
         {selectTypeSearch.map((opzione, index) => (
          <MenuItem key={index} value={opzione}>
            {opzione}
          </MenuItem>
        ))}
        </Select>
     <TextField
     margin="normal"
     placeholder=""
     required
     fullWidth
     value={giorni}
     variant="standard"
     helperText=""
     id="search"
     name="search"
     autoComplete="search"
     onChange={handleChangeGiorni}
     autoFocus
     sx={{
      width: '190px',
      height: '30px', 
      padding: 0, 
      '& .MuiInputBase-root': {
        border: '1px solid #ced4da', 
        borderRadius: '4px', 
      },
      marginTop: '5px', 
    }}
   />
   <IconButton
      id="basic-button"
      aria-controls={open ? 'basic-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={open ? 'true' : undefined}
      onClick={handleClearGiorni}
      title="Pulisci"
    >
      <CancelIcon></CancelIcon>
    </IconButton>

   
   
   
</div>

  )}
  
  
</div>
)}

</div>
  </Menu>
    );
  };
  
  export default FilterMenuMonitoraggio;
  